import { BRANCHING_NODES_TYPES } from '@/orchestrate/journeys/constants';

function findStartNode (selectedLayout) {
    return selectedLayout.messageGraph.nodes.find((node) => node.nodeType === BRANCHING_NODES_TYPES.START);
}

// Sets the start node IDs in the selected layout to match journey's start node
// Updates both the start node in the nodes array and the messageGraph's startNodeId
export function setStartNodeIds (selectedLayout, journeyStartNodeId) {
    const startNode = findStartNode(selectedLayout);

    if (startNode) {
        startNode.id = journeyStartNodeId;
    }

    selectedLayout.messageGraph.startNodeId = journeyStartNodeId;

    return selectedLayout.messageGraph;
}

// Initializes node ID mapping for journey templates
// Creates a mapping from template node IDs to journey node IDs
export function initializeNodeIdMapping (selectedLayout, journeyStartNodeId) {
    const startNode = findStartNode(selectedLayout);

    const originalStartNodeId = startNode ? startNode.id : selectedLayout.messageGraph.startNodeId;

    return {
        [originalStartNodeId]: journeyStartNodeId,
    };
}

// Processes regular guide nodes by setting their message data IDs
export function processRegularNodes (regularNodes) {
    regularNodes.forEach(({ guideId, messageNode }) => {
        messageNode.messageData.id = guideId;
    });

    return regularNodes;
}

// Updates condition nodes with new guide IDs by recursively updating guideId references
export function updateConditionNodes (selectedLayout, regularNodes, emailNodes) {
    // Create mapping from node ID to guide ID
    const nodeIdToGuideIdMap = {};

    [...regularNodes, ...emailNodes].forEach(({ nodeId, guideId }) => {
        nodeIdToGuideIdMap[nodeId] = guideId;
    });

    // Helper function to recursively update guideId references
    const updateGuideIdInObject = (obj) => {
        if (obj && typeof obj === 'object') {
            for (const key in obj) {
                if (key === 'guideId' && nodeIdToGuideIdMap[obj[key]]) {
                    obj[key] = nodeIdToGuideIdMap[obj[key]];
                } else if (typeof obj[key] === 'object') {
                    updateGuideIdInObject(obj[key]);
                }
            }
        }
    };

    // Update audienceData in condition nodes
    selectedLayout.messageGraph.nodes.forEach((node) => {
        if (node.nodeType === BRANCHING_NODES_TYPES.CONDITION && node.audienceData) {
            updateGuideIdInObject(node.audienceData);
        }
    });

    return selectedLayout;
}
